"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./toggle.sass");

var mouseEvents = ['onClick', 'onMouseDown', 'onMouseUp', 'onMouseMove'];

var Toggle = function Toggle(props) {
  var children = props.children,
      className = props.className,
      indeterminate = props.indeterminate,
      checked = props.checked,
      disabled = props.disabled,
      inputProps = (0, _objectWithoutProperties2.default)(props, ["children", "className", "indeterminate", "checked", "disabled"]);
  var labelProps = {
    className: (0, _classnames.default)('toggle', className)
  };

  if (checked != undefined) {
    inputProps.checked = checked;

    inputProps.ref = function (el) {
      if (el) {
        el.indeterminate = !checked && indeterminate;
      }
    };
  }

  mouseEvents.forEach(function (eventName) {
    if (inputProps[eventName]) {
      labelProps[eventName] = inputProps[eventName];
      delete inputProps[eventName];
    }
  });
  return _react.default.createElement("span", labelProps, _react.default.createElement("input", (0, _extends2.default)({
    type: "checkbox",
    className: "toggle-input"
  }, (0, _objectSpread2.default)({}, inputProps, {
    disabled: disabled
  }))), _react.default.createElement("b", {
    className: "toggle-box"
  }, _react.default.createElement("b", {
    className: (0, _classnames.default)('toggle-box-thumb')
  })), children ? _react.default.createElement("span", {
    className: "toggle-label"
  }, children) : null);
};

Toggle.propTypes = process.env.NODE_ENV !== "production" ? {
  onClick: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onMouseUp: _propTypes.default.func,
  onMouseMove: _propTypes.default.func,
  checked: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool,
  className: _propTypes.default.string
} : {};
var _default = Toggle;
exports.default = _default;